<ng-container *transloco="let t">
    @if (race) {
    <div class="pt-3">
      <app-my-upcoming-heading
        [event]="event"
        [race]="race"
        [countries]="countries"
        [languages]="languages"
        [type]="MyUpcomingHeadingType.RACE"
      >
      <div class="pt-3">
        @for (competitor of race.competitors; track competitor;let isLast = $last; let ind = $index) {
        <div class="competitor-row py-3" [class.isLast]="isLast" [class.isFirst]="ind === 0">
            <div class="d-flex justify-content-between">
                <div>
                    <div class="flex-grow-1 flex-md-column flex-row ps-0 ps-md-3">
                        <div class="info">
                            <p class="info__small">{{ t('app.common.competitor') }}</p>
                            <p class="medium text-uppercase">
                                {{competitor.fullName}}
                            </p>
                        </div>

                        @if (competitor.registration?.registrationStatus === RegistrationStatus.RESERVED_FOR_PAYMENT) {
                        <div class="info-details d-flex mb-2 mb-md-0">
                            <div class="info">
                                <p class="info__small">
                        {{t('app.register.to.race.confirmation.registration.is.valid.until', {
                        date: competitor.registration?.endDateForPayment! |
                        date: 'dd.MM.yyyy HH:mm': undefined: translocoService.getActiveLang()}
                        )}}
                        </p>
                        </div>
                        </div>
                        }
                    </div>
                </div>


                <div class="flex-row justify-content-end">
                    <div class="badge-holder justify-content-end mb-3">
                        <div class="badge-holder__badge"
                             [ngClass]="{
                    'finished': competitor.registration?.registrationStatus === RegistrationStatus.CONFIRMED,
                    'to-be-started': competitor.registration?.registrationStatus === RegistrationStatus.RESERVED_FOR_PAYMENT,
                    }"
                        >
                              <span class="text-uppercase">
                    {{ t('registration.status.' + competitor.registration?.registrationStatus) }}
                  </span>
                        </div>
                    </div>
                    <div class="d-none d-md-flex">
                        @if (displayPayButton(competitor)) {
                        <!-- Action Buttons -->
                        <div class="d-flex flex-column flex-md-row align-items-end btn-holder">
                             <ng-container *ngTemplateOutlet="payButton;  context: { competitor: competitor }"></ng-container>
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="d-flex d-md-none justify-content-center">
                @if (displayPayButton(competitor)) {
                <!-- Action Buttons -->
                <div class="d-flex flex-column flex-md-row align-items-end btn-holder">
                   <ng-container *ngTemplateOutlet="payButton;  context: { competitor: competitor }"></ng-container>
                </div>
                }
            </div>
    </div>

    <ng-template #payButton let-competitor="competitor">
        <div class="ps-0 ps-md-2 pt-3 pt-md-0">
            <app-button-alt
                    [buttonColor]="'transparent'"
                    [textColor]="'var(--grey-neutral-800)'"
                    [borderColor]="'var(--teal-500)'"
                    [isFullWidth]="true"
                    [text]="t('app.register.to.race.pay.with.card')"
                    (onClickCallback)="onContinueWithPayment(competitor)"
                    [buttonHeight]="'36px'"
            ></app-button-alt>
        </div>
    </ng-template>

    }
    </div>
    </app-my-upcoming-heading>
  </div>
    }
</ng-container>
